import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import MedicineActions, { MedicineRedux, MedicineTypes } from '../../Redux/ParentPlatform/MedicineRedux'
import MedicinesActions from '../../Redux/MedicinesCenterRedux'
import { notificationSuccess, notificationFail } from '../../Redux/NotificationActions'

const MedicineCRUDObservable = createCRUDObservable({
  mainRedux: MedicineRedux,
  reduxPath: 'parent_platform_medicine',
})

const createMedicineEpic = (action$, store, { Api }) => (
  action$.ofType(MedicineTypes.createMedicineRequest)
    .mergeMap(({ medicineInfo }) => (
      Api.parent_platform_medicine.create(medicineInfo)
        .then(response => response)
        .catch(err => err)
    ))
    .flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [
          MedicineActions.createMedicineError(response.error),
          notificationFail('Accion Fallida'),
        ]
      }
      return [
        MedicineActions.createMedicineSuccess(response.data.data),
        MedicinesActions.updateMedicines(response.data.data),
        notificationSuccess('Accion Exitosa'),
      ]
    })
)

export const medicineObservers = Object.assign({}, MedicineCRUDObservable.observers, {})
export const medicineEpic = combineEpics(
  MedicineCRUDObservable.epic,
  createMedicineEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/MedicineObserver.js